import React, { useEffect, useState } from 'react';
import { apiFetch } from '../../utils/api';

const savedUser = () => {
    try {
        return JSON.parse(localStorage.getItem('user')) || {};
    } catch {
        return {};
    }
};

const Profile = () => {
    const [form, setForm] = useState(() => {
        const u = savedUser();
        return { name: u.name || '', phone: u.phone || '', email: u.email || '' };
    });
    const [saved, setSaved] = useState(false);
    const [error, setError] = useState('');

    // load the real profile from the API
    useEffect(() => {
        let cancelled = false;
        apiFetch('/users/me').then(({ ok, data }) => {
            if (!cancelled && ok) {
                setForm({ name: data.name || '', phone: data.phone || '', email: data.email || '' });
            }
        });
        return () => {
            cancelled = true;
        };
    }, []);

    const handleChange = (e) => {
        setSaved(false);
        setError('');
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSaved(false);
        setError('');

        const { ok, data } = await apiFetch('/users/me', { method: 'PUT', body: form });
        if (!ok) {
            setError(data.message || 'Could not update your profile.');
            return;
        }
        localStorage.setItem('user', JSON.stringify(data));
        window.dispatchEvent(new Event('user-updated')); // refreshes the name in the account sidebar
        setSaved(true);
    };

    const field = 'w-full rounded-md border border-gray-200 px-3 py-2.5 text-sm outline-none focus:border-[#2f6b1f]';
    const label = 'mb-1 block text-xs text-gray-500';

    return (
        <>
            <h1 className="text-xl font-semibold">Profile</h1>
            <form onSubmit={handleSubmit} className="mt-5 max-w-lg space-y-4 rounded-xl border border-gray-200 bg-white p-6 shadow-sm">
                <div>
                    <label htmlFor="name" className={label}>Full Name</label>
                    <input id="name" name="name" value={form.name} onChange={handleChange} className={field} />
                </div>
                <div>
                    <label htmlFor="phone" className={label}>Mobile Number</label>
                    <input id="phone" name="phone" value={form.phone} onChange={handleChange} className={field} />
                </div>
                <div>
                    <label htmlFor="email" className={label}>Email Address</label>
                    <input id="email" type="email" name="email" value={form.email} onChange={handleChange} className={field} />
                </div>
                <button type="submit" className="rounded-md bg-[#2f6b1f] px-6 py-2.5 text-sm font-semibold text-white hover:brightness-110">Save changes</button>
                {saved && <p role="status" className="text-xs text-[#2f6b1f]">Profile updated.</p>}
                {error && <p role="alert" className="text-xs text-red-600">{error}</p>}
            </form>
        </>
    );
};

export default Profile;
